import { unstable_HistoryRouter as Router } from 'react-router';

import { history } from '@vk-hr-tek/core/history';
import { Box } from '@vk-hr-tek/ui/Box';
import { CircularProgress } from '@vk-hr-tek/ui/CircularProgress';

import { init } from '@app/init';
import { metaTitles } from '@app/router';
import { InjectReducerContextProvider } from '@app/context';
import { useSelector } from '@app/hooks';

import {
  GeneralLayout,
  CandidateLayout,
  AbilityProvider,
  TranslationsProvider,
  VKHRTekUIProvider,
} from './layout';
import { selectRefreshing } from './layout/slice';
import { InjectReducer } from './app/types';
import { useApplication } from './auth/hooks/useApplication';
import CandidateApp from './CanidateApp';
import MainApp from './MainApp';

init({ history });

interface AppProps {
  injectReducer: InjectReducer;
}

function App({ injectReducer }: AppProps) {
  const appType = useApplication();
  const isRefreshing = useSelector(selectRefreshing);

  const appContent =
    appType === 'candidateApp' ? (
      <CandidateLayout>
        <CandidateApp />
      </CandidateLayout>
    ) : (
      <GeneralLayout metaTitles={metaTitles}>
        <MainApp />
      </GeneralLayout>
    );

  return (
    <TranslationsProvider>
      <AbilityProvider role="employee">
        <InjectReducerContextProvider injectReducer={injectReducer}>
          <VKHRTekUIProvider>
            <Router history={history} useTransitions={false}>
              {appContent}
              {isRefreshing && (
                <Box
                  position="fixed"
                  top="0"
                  left="0"
                  width="100%"
                  height="100%"
                  zIndex={2000}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bgcolor="bg.light.primary"
                  role="status"
                  aria-label="Загрузка"
                >
                  <CircularProgress size={50} />
                </Box>
              )}
            </Router>
          </VKHRTekUIProvider>
        </InjectReducerContextProvider>
      </AbilityProvider>
    </TranslationsProvider>
  );
}

export default App;
